import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// =========================================================================
// LOGIC CỨU HỘ: HỦY ĐĂNG KÝ SERVICE WORKER VÀ XÓA TẤT CẢ CACHE
// (ĐẶT Ở ĐẦU FILE main.ts CỦA BẠN)
// =========================================================================
(function () {
  // ----------------------------------------------------------------------
  // CẦN THAY THẾ GIÁ TRỊ NÀY TRONG QUÁ TRÌNH BUILD/DEPLOY
  const CURRENT_APP_HASH = "20251211_d9a2e2";
  // ----------------------------------------------------------------------

  const CACHED_HASH_KEY = "app_build_hash_v2"; // Dùng key mới để không bị ảnh hưởng bởi key cũ
  const cachedHash = localStorage.getItem(CACHED_HASH_KEY);

  // Nếu có một Hash mới (hash cũ không tồn tại hoặc không khớp)
  if (!cachedHash || cachedHash !== CURRENT_APP_HASH) {
    console.warn("!!! FORCE CACHE CLEARING ACTIVATED !!!");
    console.log(`Old Hash: ${cachedHash} | New Hash: ${CURRENT_APP_HASH}`);

    let shouldReload = false;

    // 1. Xóa TẤT CẢ Service Workers (Nguồn gốc của việc phục vụ file cũ)
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
          console.log(`Unregistered Service Worker: ${registration.scope}`);
          shouldReload = true;
        });
      });
    }

    // 2. Xóa TẤT CẢ Cache API (Nơi Service Worker lưu trữ các file tĩnh)
    if ("caches" in window) {
      caches.keys().then((cacheNames) => {
        return Promise.all(
          cacheNames.map((cacheName) => {
            console.log(`Deleting Cache API: ${cacheName}`);
            shouldReload = true;
            return caches.delete(cacheName);
          })
        );
      });
    }

    // 3. Xóa Local Storage/IndexedDB (Nguồn gốc của lỗi màn hình trắng)
    console.log("Clearing localStorage/IndexedDB data...");
    localStorage.clear();
    indexedDB.deleteDatabase("ngsw"); // Nếu bạn dùng Angular Service Worker mặc định (NGSW)

    // 4. Cập nhật Hash mới
    localStorage.setItem(CACHED_HASH_KEY, CURRENT_APP_HASH);

    // 5. Nếu có bất kỳ hành động xóa nào được thực hiện, buộc tải lại trang
    if (shouldReload) {
      console.log("Waiting 3 seconds then forcing hard reload...");
      // Chờ một chút để các thao tác xóa cache/SW hoàn tất
      setTimeout(() => {
        window.location.reload(); // Buộc tải lại từ server
      }, 3000);

      // Ngăn Angular khởi động
      throw new Error(
        "Forced cache clear/SW unregister initiated, application restart imminent."
      );
    }
  }

  console.log(`App version ${CURRENT_APP_HASH} is running.`);
})();
